import React, { useState } from "react";
import "../CategoryHeader/CategoryHeader.css";
import CategoryOverlay from "../CategoryOverlay";
import DatePicker from "react-datepicker";
import { FaCalendarAlt } from "react-icons/fa";

const CategoryHeader = ({
    search,
    setSearch,
    columnSearch,
    setColumnSearch,
    onRefresh,
}) => {
    const [showOverlay, setShowOverlay] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const handleRefresh = () => {
        setSearch("");
        setStartDate(null);
        setEndDate(null);
        setColumnSearch({status:"Active",
            categoryName: "",
        description: "",
        companyName: "",
        createdBy: "",
        lastUpdated: "",
        });
        if (onRefresh) {
            onRefresh();
        }
    };

    return (
        <>
            <div className="category-list-header">
                <div className="category-list-header-left">
                    <input
                        type="text"
                        placeholder="Search..."
                        value={search}
                        className="category-list-search-input"
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <div className="category-list-date-wrapper">
                        <DatePicker
                            selected={startDate}
                            onChange={(date) => {
                                setStartDate(date);
                                setColumnSearch({
                                    ...columnSearch,
                                    startDate: date,
                                });
                            }}
                            placeholderText="Start Date"
                            dateFormat={"dd-MM-yyyy"}
                            className="category-list-date-picker"
                            popperPlacement="bottom-start"
                            showPopperArrow={false}
                            portalId="root"
                        />
                        <FaCalendarAlt className="category-list-calendar-icon" />
                    </div>
                    <div className="category-list-date-wrapper">
                        <DatePicker
                            selected={endDate}
                            onChange={(date) => {
                                setEndDate(date);
                                setColumnSearch({
                                    ...columnSearch,
                                    endDate: date,
                                });
                            }}
                            placeholderText="End Date"
                            dateFormat={"dd-MM-yyyy"}
                            className="category-list-date-picker"
                            popperPlacement="bottom-start"
                            showPopperArrow={false}
                            portalId="root"
                        />
                        <FaCalendarAlt className="category-list-calendar-icon" />
                    </div>
                </div>

                <div className="category-list-header-right">
                    <span
                        className="coinallot-refresh-icon"
                        title="Refresh"
                        onClick={handleRefresh}
                    >
                        ⟳
                    </span>

                    <span
                        className="category-add-plus"
                        onClick={() => setShowOverlay(true)}
                    >
                        +
                    </span>
                </div>
            </div>
            {showOverlay && (
                <CategoryOverlay
                    onClose={() => setShowOverlay(false)}
                    onSave={() => {
                        setShowOverlay(false);
                        if (onRefresh) onRefresh();
                    }}
                />
            )}
        </>
    );
};

export default CategoryHeader;
